export default __webpack_public_path__ + "static/media/mn-large.06c4956c.png";